<template>
  <section class="tables new-updated-design">
    <div class="container-property">
      <vue-snotify></vue-snotify>
      <div class="row">
        <div class="container">
          <div class=""
            style="display: flex; align-items: center; justify-content: space-between; gap: 10px; flex-wrap: wrap;">
            <Button class="btn btn-primary" style="margin-right: 10px !important;" @click="goBack">{{
              $t('register.back') }}</Button>
            <div class="" v-if="this.taxinvoice">
              <p v-if="this.taxinvoice.status == 0"
                style="padding: 10px; border: 2px solid black; border-radius: 20px;">{{
                  $t('invoice.tax_invoice_requested') }}</p>
              <p v-if="this.taxinvoice.status == 1"
                style="padding: 10px; border: 2px solid black; border-radius: 20px;">{{ $t('invoice.tax_invoice_sent')
                }}</p>
            </div>
            <div class="" v-else>
              <!-- <a :href="paymentdetails.pdf_path" target="_blank">
                <Button class="btn btn-primary" style="margin-right: 10px !important;">
                  Download Invoice
                </Button>
              </a> -->
              <!-- <Button class="btn btn-primary" style="margin-right: 10px !important;">Download Invoice</Button> -->
              <a class="btn btn-primary"
                @click.prevent="requestTaxInvoice(paymentdetails.id, paymentdetails.property.user_id)">{{
                  $t('invoice.request_tax_invoice') }}</a>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-lg-12">
              <h3>{{ $t('Propertis.Customer_Information') }}</h3>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-lg-5">
              <label>{{ $t('register.name') }}: <span> {{ this.paymentdetails.first_name }} {{
                this.paymentdetails.last_name }}</span>
              </label>
            </div>
            <div class="col-lg-4">
              <label>{{ $t('login.email') }}: <span> {{ this.paymentdetails.email }}</span></label>
            </div>
            <div class="col-lg-3">
              <label>{{ $t('register.phone') }}: <span> {{ this.paymentdetails.phone_number }}</span></label>
            </div>
          </div>
          <hr>
          <div class="row mt-4">
            <div class="col-lg-12">
              <h3>{{ $t('Propertis.Reservation_Details') }}</h3>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12">
              <div class="table-responsive">
                <table class="table">
                  <thead class="table-head-custom">
                    <tr>
                      <th>{{ $t('Propertis.Title') }}</th>
                      <th>{{ $t('Propertis.Description') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ $t('Propertis.Accommodation_Name') }}:</td>
                      <td>{{ this.paymentdetails.property.property_type }}</td>
                    </tr>
                    <tr>
                      <td>{{ $t('Propertis.Accommodation_Address') }}:</td>
                      <td>{{ this.paymentdetails.property.address }}</td>
                    </tr>
                    <tr>
                      <td>{{ $t('dashboard.check_in_date') }}:</td>
                      <td>{{ formatDate(this.paymentdetails.start_date) }} </td>
                    </tr>
                    <tr>
                      <td>{{ $t('dashboard.check_out_date') }}:</td>
                      <td>{{ formatDate(this.paymentdetails.end_date) }}</td>
                    </tr>
                    <tr>
                      <td>{{ $t('Propertis.Length_of_Stay') }}: </td>
                      <td>{{ this.paymentdetails.number_of_nights }} {{ $t('Propertis.nights') }}</td>
                    </tr>
                    <tr>
                      <td>{{ $t('Propertis.Accommodation_Type_Reserved') }}:</td>
                      <td> {{ this.paymentdetails.property.accommodation_type }}
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t('Propertis.number_of_guests') }}:</td>
                      <td>{{ this.paymentdetails.number_of_guests }} </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <hr>
          <div class="row mt-4">
            <div class="col-lg-12">
              <h3>{{ $t('Propertis.Financial_Details') }}</h3>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12">
              <div class="table-responsive">
                <table class="table">
                  <thead class="table-head-custom">
                    <tr>
                      <th>{{ $t('Propertis.Title') }}</th>
                      <th>{{ $t('Propertis.Description') }}</th>
                      <th>{{ $t('booking.Amount') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ $t('booking.total_price') }}:</td>
                      <td>{{ $t('Propertis.Total_Reservation_Description') }}</td>
                      <td>{{ this.paymentdetails.payment_currency }} {{ this.paymentdetails.total_price }}</td>
                    </tr>
                    <tr>
                      <td>{{ $t('Propertis.Currency') }}:</td>
                      <td>{{ this.paymentdetails.payment_currency }}</td>
                      <td> </td>
                    </tr>
                    <tr>
                      <td>{{ $t('invoice.payment_policy') }}:</td>
                      <td>{{ $t('Propertis.Payment_Policy_Description') }}</td>
                      <td> </td>
                    </tr>
                    <tr>
                      <td>{{ $t('invoice.cancellation_refund_policy') }}:</td>
                      <td colspan="2">
                        {{ $t('Propertis.Cancellation_Description') }}.
                        <a href="/cancellation-and-refund-policy" target="_blank">
                          {{ $t('invoice.view_cancellation_policy') }}
                        </a>
                      </td>
                      <td> </td>
                    </tr>
                    <tr>
                      <td>{{ $t('payment.discounted_amount') }}:</td>
                      <td></td>
                      <td>{{ this.paymentdetails.payment_currency }} {{
                        this.paymentdetails.discount_amount }}</td>
                    </tr>
                    <tr>
                      <td>{{ $t('discounts.discount_percentage') }}:</td>
                      <td></td>
                      <td>{{ this.paymentdetails.discount_percentage }}%</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <hr>
          <div class="row mt-4">
            <div class="col-lg-12">
              <h3 class="title">{{ $t('Propertis.Other_Details') }}</h3>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12">
              <div class="table-responsive">
                <table class="table">
                  <thead class="table-head-custom">
                    <tr>
                      <th>{{ $t('Propertis.Title') }}</th>
                      <th>{{ $t('Propertis.Description') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ $t('property_detail.Property_Policies') }}:</td>
                      <td v-html="propertyPolicies"></td>
                    </tr>
                    <tr>
                      <td>{{ $t('Propertis.Included_Services') }}:</td>
                      <td>{{ includedServices }}</td>
                    </tr>
                    <tr v-if="user.email || user.mobile_phone">
                      <td>{{ $t('Propertis.Property_Contact_Information') }}:</td>
                      <td>
                        <template v-if="user.email && user.mobile_phone">
                          {{ user.email }} <b>{{ $t('common.and') }}</b> {{ user.mobile_phone }} {{
                            $t('common.for_inquiries') }}
                        </template>
                        <template v-else-if="user.email">
                          {{ user.email }} {{ $t('common.for_inquiries') }}
                        </template>
                        <template v-else-if="user.mobile_phone">
                          {{ user.mobile_phone }} {{ $t('common.for_inquiries') }}
                        </template>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <hr>
          <div class="row">
            <div class="col-lg-6">
            </div>
            <div class="col-lg-6 d-flex justify-content-end footer-text">
              <h3 style="margin-right: 10px !important;">{{ $t('booking.total_price') }}:</h3>
              <h3 style="margin-right: 10px !important; color: #70d3ff;">{{ this.paymentdetails.payment_currency }} {{
                this.paymentdetails.total_price }} </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from "vue";
import API from "@/api";
import moment from 'moment';
import BarChart from "../components/charts/chartjs/barChart.vue";
import Swal from 'sweetalert2';

export default {
  data() {
    return {
      paymentdetails: '',
      user: '',
      taxinvoice: '',
    };
  },
  methods: {
    formatTime(time) {
      const [hours, minutes] = time.split(':'); // Split the time into hours and minutes
      const date = new Date();
      date.setHours(hours);
      date.setMinutes(minutes);

      let hour = date.getHours();
      const minute = date.getMinutes();
      const period = hour >= 12 ? 'PM' : 'AM';

      hour = hour % 12 || 12; // Convert 24-hour time to 12-hour time
      const formattedTime = `${hour}:${minute < 10 ? '0' + minute : minute} ${period}`;

      return formattedTime;
    },
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY');
    },
    getInvoicedetail() {
      const invoiceId = this.$route.params.id;
      API.getInvoicedetails(invoiceId,
        data => {
          this.paymentdetails = data.data.Details;
          this.user = data.data.User;
          this.taxinvoice = data.data.taxinvoice
        },
        err => {
          console.log(err);
        });
    },
    requestTaxInvoice(id, uid) {
      API.addTaxRequest({ id: id },
        data => {
          if (data.message) {
            Swal.fire({
              icon: 'success',
              type: 'success',
              title: this.$t('alerts.success'),
              text: this.$t('invoice.tax_invoice_success'),
              // text: data.message,
              confirmButtonText: this.$t('sweetalert.OK'),
            })
              .then((result) => {
                if (result.value) {
                  this.taxinvoice = data.tax_invoice;
                }
              });
          } else if (data.error) {
            this.handleApiError(data.error);
          }

        }, err => {
          console.log(err)
        })
    },
    goBack() {
      if (this.$router) {
        this.$router.push({ name: 'my_bookings' });
      } else {
        this.$router.push({ name: 'Home' });
      }
    },
  },

  mounted() {
    this.getInvoicedetail();
  },
  computed: {
    includedServices() {
      const services = [];
      const property = this.paymentdetails.property;

      if (property.wifi_available == 1) services.push(this.$t('Propertis.Wifi'));
      if (property.tv_available == 1) services.push(this.$t('Propertis.TV'));
      if (property.kitchen_available == 1) services.push(this.$t('Propertis.Kitchen'));

      return services.length ? services.join(', ') : this.$t('common.none');
    },

    propertyPolicies() {
      const property = this.paymentdetails.property;
      const categories = [
        { key: 'Children', label: 'children_are', value: property.children },
        { key: 'Events', label: 'events_are', value: property.Events },
        { key: 'Pets', label: 'pets_are', value: property.Pets },
        { key: 'Smoking', label: 'smoking_is', value: property.Smoking },
      ];

      const normalizeKey = (str) => {
        if (!str) return 'Not Allowed';
        return str.trim()
          .replace(/\s+/g, '_')           // replace spaces with underscores
          .replace(/[^a-zA-Z0-9:_-]/g, '') // remove bad characters
          .replace(/Allowd/, 'Allowed');   // fix DB typo if any
      };

      const policies = categories.map(cat => {
        const rawValue = cat.value || 'Not Allowed';
        const normalizedKey = normalizeKey(rawValue);

        // dynamic translation key
        const translationKey = `Propertis.Policies.${cat.key}.${normalizedKey}`;
        const hasTranslation = this.$te(translationKey);

        const translatedValue = hasTranslation
          ? this.$t(translationKey)
          : this.$t('common.not_allowed'); // fallback default

        return this.$t(`Propertis.${cat.label}`, {
          [cat.key.toLowerCase()]: translatedValue,
        });
      });

      return policies.length ? policies.join('<br>') : this.$t('invoice.no_policies');
    }

  },
  created() {
  }
};
</script>
<style>
.table-head-custom {
  background-color: #70d3ff;
  /* Green background */
  color: white;
  /* White text */
}

.footer-text h3 {
  font-size: 22px;
}

.col-lg-12 h3 {
  font-size: 25px;
  margin: 0;
}

@media (max-width: 767px) {
  .col-lg-12 h3 {
    font-size: 20px;
    margin: 0;
  }

  .footer-text h3 {
    font-size: 18px;
  }
}

@media (max-width: 574.98px) {
  .footer-text h3 {
    font-size: 16px;
  }
}
</style>